import PropTypes from 'prop-types'
import { styled } from '@mui/material/styles'

const PREFIX = 'Layout'

const classes = {
  wrapper: `${PREFIX}-wrapper`,
}

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.wrapper}`]: {
    margin: 0,
    width: 'auto',
    [theme.breakpoints.up('xs')]: {
      width: '98%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(4),
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(6),
      width: '95%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(6),
      width: '90%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(6),
      width: '85%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
}))

const LayoutWrapper = ({ children }) => {
  return <Root className={classes.wrapper}>{children}</Root>
}
LayoutWrapper.propTypes = {
  children: PropTypes.any,
}

export { LayoutWrapper }
